// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.v-breadcrumbs .v-breadcrumbs__divider[data-v-7a7777ff],.theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled[data-v-7a7777ff]{color:#ffebee}.accessKeyU[data-v-7a7777ff]{color:#08202f}a[data-v-7a7777ff]:focus{border:2px dashed #da7b19;color:#f8f8f8}", ""]);
// Exports
module.exports = exports;
